exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.currencyImg[data-v-36a6427c] {\n    vertical-align: middle;\n}\n", ""]);
